import { render, staticRenderFns } from "./CPageBlogDetailStandard.vue?vue&type=template&id=baa4818a&"
import script from "./CPageBlogDetailStandard.vue?vue&type=script&lang=ts&"
export * from "./CPageBlogDetailStandard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports